export const setLoadingData = (data) => ({
  type: 'SET_LOADING_DATA',
  data,
});
